import { render, staticRenderFns } from "./LegsComponent.vue?vue&type=template&id=7bc9fbe2&scoped=true"
import script from "./LegsComponent.vue?vue&type=script&lang=js"
export * from "./LegsComponent.vue?vue&type=script&lang=js"
import style0 from "./LegsComponent.vue?vue&type=style&index=0&id=7bc9fbe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc9fbe2",
  null
  
)

export default component.exports